import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'VisitchkPipe',
})
@Injectable()
export class VisitchkPipe implements PipeTransform {
    transform(items: any[],  value: string): boolean {
   if (!items || items == []) return false;
   if (!value) return false;
   else {
       return items.includes(value)
   }
}
}